// File: src/components/Header.jsx

import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Box,
} from "@mui/material";

import LanguageIcon from "@mui/icons-material/Language";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import { useAuth } from "../context/AuthContext";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n, t } = useTranslation();
  const { logout } = useAuth();

  const [anchorElLang, setAnchorElLang] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleLogout = async () => {
    await logout();
  };

  return (
    <AppBar position="sticky" color="primary" elevation={2}>
      <Toolbar sx={{ display: "flex", gap: 1 }}>
        
        {/* 🔙 زر الرجوع */}
        <IconButton
          color="inherit"
          onClick={() => navigate(-1)}
          disabled={location.pathname === "/dashboard"} 
        >
          <ArrowBackIcon />
        </IconButton>

        {/* 🏠 زر الرئيسية */}
        <IconButton color="inherit" onClick={() => navigate("/dashboard")}>
          <HomeIcon />
        </IconButton>

        {/* عنوان الصفحة */}
        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: "bold" }}>
          {t("common.dashboard")}
        </Typography>

        {/* 🌐 زر اللغة */}
        <Tooltip title={t("common.language")}>
          <IconButton color="inherit" onClick={(e) => setAnchorElLang(e.currentTarget)}>
            <LanguageIcon />
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorElLang}
          open={Boolean(anchorElLang)}
          onClose={() => setAnchorElLang(null)}
        >
          <MenuItem onClick={() => { i18n.changeLanguage("ar"); setAnchorElLang(null); }}>
            {t("common.arabic")}
          </MenuItem>
          <MenuItem onClick={() => { i18n.changeLanguage("en"); setAnchorElLang(null); }}>
            {t("common.english")}
          </MenuItem>
        </Menu>

        {/* ⚙️ زر الحساب */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography 
            variant="body2" 
            sx={{ 
              display: { xs: 'none', sm: 'block' },
              fontWeight: '500',
              color: 'inherit',
              opacity: 0.9
            }}
          >
            {localStorage.getItem("userName")}
          </Typography>
          <Tooltip title={t("common.settings")}>
            <IconButton color="inherit" onClick={(e) => setAnchorElUser(e.currentTarget)}>
              <AccountCircleIcon />
            </IconButton>
          </Tooltip>
        </Box>

        <Menu
          anchorEl={anchorElUser}
          open={Boolean(anchorElUser)}
          onClose={() => setAnchorElUser(null)}
        >
          <MenuItem onClick={() => { navigate('/company/profile'); setAnchorElUser(null); }}>
            {t("companyDefinitions.companyProfile")}
          </MenuItem>
          
          <MenuItem onClick={() => { navigate('/change-password'); setAnchorElUser(null); }}>
            {t("common.change_password")}
          </MenuItem>

          <MenuItem onClick={() => { navigate('/change-username'); setAnchorElUser(null); }}>
            {t("common.change_username")}
          </MenuItem>

          <MenuItem onClick={() => { navigate('/change-mobile'); setAnchorElUser(null); }}>
            {t("common.change_mobile")}
          </MenuItem>
          
          <MenuItem onClick={handleLogout}>{t("common.logout")}</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
